module.exports = __webpack_public_path__ + "static/media/file_type_doc.e3d0af5d.svg";